export default "__VITE_ASSET__Ccjcnjw9__"